import api from "../utils/api";

const ADMIN_BASE_PATH = "/admin";

export interface IAdminSettings {
  sendConfirmationEnabled: boolean;
  confirmationSendDaysBeforeDelivery: number;
  services: { name: string; default: boolean; qboItemName?: string }[];
  truckNumbers: string[];
  driverInitials: string[];
}

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const AdminSettingsModel = {
  getSettings: async (): Promise<IAdminSettings> => {
    try {
      const response = await api.get<IAdminSettings>(`${ADMIN_BASE_PATH}/confirmationSettings`, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (e: any) {
      console.error(e);
      throw e;
    }
  },

  updateSettings: async (settings: IAdminSettings): Promise<IAdminSettings> => {
    try {
      const response = await api.put<IAdminSettings>(`${ADMIN_BASE_PATH}/confirmationSettings`, settings, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (e: any) {
      console.error(e);
      throw e;
    }
  },

  getServices: async (): Promise<IAdminSettings[]> => {
    try {
      const response = await api.get<IAdminSettings[]>(`${ADMIN_BASE_PATH}/services`, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (e: any) {
      console.error(e);
      throw e;
    }
  },

  updateServices: async (settings: Partial<IAdminSettings>): Promise<IAdminSettings> => {
    try {
      const response = await api.put<IAdminSettings>(`${ADMIN_BASE_PATH}/services`, settings, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (e: any) {
      console.error(e);
      throw e;
    }
  },

  getTruckNumbers: async (): Promise<string[]> => {
    try {
      const response = await api.get<string[]>(`${ADMIN_BASE_PATH}/truckNumbers`, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (e: any) {
      console.error(e);
      throw e;
    }
  },

  updateTruckNumbers: async (truckNumbers: Partial<IAdminSettings>): Promise<IAdminSettings> => {
    try {
      const response = await api.put<IAdminSettings>(`${ADMIN_BASE_PATH}/truckNumbers`, truckNumbers, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (e: any) {
      console.error(e);
      throw e;
    }
  },

  getDriverInitials: async (): Promise<string[]> => {
    try {
      const response = await api.get<string[]>(`${ADMIN_BASE_PATH}/driverInitials`, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (e: any) {
      console.error(e);
      throw e;
    }
  },

  updateDriverInitials: async (driverInitials: Partial<IAdminSettings>): Promise<IAdminSettings> => {
    try {
      const response = await api.put<IAdminSettings>(`${ADMIN_BASE_PATH}/driverInitials`, driverInitials, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (e: any) {
      console.error(e);
      throw e;
    }
  },
};

